module.exports = __webpack_public_path__ + "0599598615617f1b17fb1634683a9a24.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Message/videos/cnn-richard-prince.mp4
 ** module id = 350
 ** module chunks = 0
 **/